"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _urls = _interopRequireDefault(require("./urls"));

class SupportService {
  constructor(baseUrl, httpClient) {
    this.httpClient = httpClient;
    this.urls = (0, _urls.default)(baseUrl);
  }
  /**
   * Sends a user support message message via intercom API
   * @param {string} message
   */


  async sendSupportMessage(message) {
    const response = await this.httpClient.post(this.urls.SEND_SUPPORT_MESSAGE, {
      message
    });

    if (!response) {
      return false;
    }

    return true;
  }

}

var _default = SupportService;
exports.default = _default;